import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="App-footer">
      <div className="social-links">
        <a
          href="https://www.facebook.com/chantournagepatricia"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="bi bi-facebook"></i> Facebook
        </a>
        <a
          href="https://www.instagram.com/chantournagepatricia"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="bi bi-instagram"></i> Instagram
        </a>
        <a
          href="https://www.linkedin.com/in/patricia-perrin-63b132b4"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="bi bi-linkedin"></i> LinkedIn
        </a>
      </div>

      <p className="footer-copyright">
        Copyright&nbsp;
        <Link to="/admin" className="bi-c-circleOLD copy-link">© </Link>
        2025 Deco-bois.3d-pixel.fr. Tous droits réservés.
      </p>
            <p className="footer-mentions">
        <span>Mentions Légales</span>
        <span className="separator">—</span>
        <span>Politique de Confidentialité</span>
        <span className="separator">—</span>
        <span>Conditions Générales de Vente</span>
        <span className="separator">—</span>
        <span>Politique de Retour</span>  
        <span className="separator">—</span>
        <span className="credits">Developpé par <a href="https://3d-pixel.fr">3d-pixel.fr</a></span>

      </p>
    </footer>
  );
}

export default Footer;
